<template>
  <!--
      作者 gmshop
      时间：2020-06-09
      描述：会员-等级管理-编辑等级
  -->
  <el-dialog title="编辑活动" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false" width="800px" append-to-body>
    <el-form size="small" :model="form" ref="form">
      <el-form-item label="活动名称" :label-width="formLabelWidth" prop="active_name" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.active_name" placeholder="请输入活动名称"></el-input>
      </el-form-item>
      <el-form-item label="满类型" :label-width="formLabelWidth">
        <div>
          <el-radio v-model="form.full_type" :label="1">满金额</el-radio>
          <el-radio v-model="form.full_type" :label="2">满件数</el-radio>
        </div>
      </el-form-item>
      <el-form-item label="活动时间" :label-width="formLabelWidth">
        <el-date-picker
          v-model="form.activity_time"
          type="datetimerange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
      </el-form-item>
      <el-form-item label="适用产品" prop="product_type" :rules="[{ required: true, message: ' ' }]" :label-width="formLabelWidth">
        <el-radio-group v-model="form.product_type">
          <el-radio :label="10">所有产品</el-radio>
          <el-radio :label="20">指定产品</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item v-if="form.product_type == '20'" label="选择商品" :label-width="formLabelWidth">
        <el-row>
          <el-button type="primary" icon="el-icon-plus" @click="openProductDialog">选择商品</el-button>
          <div class="draggable-list">
            <div v-for="(item,index) in products" :key="index" class="item">
              <div style="height:100%">
                <div>
                  <img class="img" :src="item.product_image" />
                  <div class="product-name2">ID：{{item.product_id}}</div>
                  <div class="product-name2">{{item.product_name}}</div>
                </div>
              </div>
              <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i class="el-icon-close"></i></a>
            </div>
          </div>
        </el-row>
      </el-form-item>

      <el-form-item label="满减规则："  :label-width="formLabelWidth">
        <el-button size="small" class="el-icon-circle-plus" @click="AddItem">添加</el-button>
        <div class="tips">
          如果是打折，填写20，表示打8折，优惠2折
        </div>
        <table border="0" cellpadding="2" cellspacing="5" class="">
          <tr>
            <th class="tl">序号</th>
            <th class="tl">满值(元)</th>
            <th class="tl">满减类型</th>
            <th class="tl">减值(优惠)</th>
            <th>操作</th>
          </tr>
          <tr v-for="(item, index) in form.setting" :key="index">
            <td width="50">{{ index+1 }}</td>
            <td>
              <el-input size="small" v-model="item.full_value" placeholder="请输入金额">
                <template slot="prepend">
                  <span>订单满</span>
                </template>
                <template slot="append">
                  <span>{{form.full_type==1?'元':'件'}}</span>
                </template>
              </el-input>
            </td>
            <td>
              <el-radio-group v-model="item.reduce_type">
                <el-radio label="1">减金额</el-radio>
                <el-radio label="2">打折</el-radio>
              </el-radio-group>
            </td>
            <td>
              <el-input size="small" v-model="item.reduce_value" placeholder="请输入优惠参数">
                <template slot="append">
                  <span>{{ item.reduce_type==1?'元':'折' }}优惠</span>
                </template>
              </el-input>
            </td>
            <td><el-button size="small" @click="delItem(index)">删除</el-button></td>
          </tr>
        </table>
      </el-form-item>


      <!-- <el-form-item label="满值" :label-width="formLabelWidth" prop="full_value" :rules="[{required: true,message: ' '}]">
        <el-input type="number" :precision="1" :step="1" :min="0" placeholder="请输入满值" v-model="form.full_value"></el-input>
      </el-form-item>
      <el-form-item label="减类型" :label-width="formLabelWidth">
        <div>
          <el-radio v-model="form.reduce_type" :label="1">减金额</el-radio>
          <el-radio v-model="form.reduce_type" :label="2">打折</el-radio>
        </div>
      </el-form-item>
      <el-form-item label="减值" :label-width="formLabelWidth" prop="reduce_value" :rules="[{required: true,message: ' '}]">
        <el-input type="number" :precision="1" :step="1" :min="0" placeholder="请输入满值" v-model="form.reduce_value"></el-input>
        <div class="tips">
          如果是打折，填写20，表示打8折，优惠2折
        </div>
      </el-form-item> -->
    </el-form>
    <Product :isproduct="open_product" :excludeIds="excludeIds" :islist="true" @closeDialog="closeProductDialog"></Product>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="edit" :disabled="submit_loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import FullreduceApi from '@/api/plus/fullreduce.js';
  import Product from '@/components/product/Product.vue';
  export default {
    components: {
      Product,
    },
    data() {
      return {
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,
        /*是否正在提交*/
        submit_loading: false,
        excludeIds:[],
        open_product: false,
        products:[],
      };
    },
    props: ['open_edit', 'form'],
    created() {
      this.excludeIds = this.form.product_ids.map(Number);
      this.products = this.form.products;
      this.dialogVisible = this.open_edit;
    },
    methods: {
      AddItem(){
        let self = this;
        let data = {'full_value':0,'reduce_type':1,'reduce_value':0};
        self.form.setting.push(data);
      },
      delItem(key){
        let self = this;
        let setting = self.form.setting;
        let newdata = [];
        setting.forEach((item,index)=>{
          if(index != key){
            newdata.push(item);
          }
        });
        self.form.setting = newdata;
      },
      /*添加商品*/
      openProductDialog() {
        this.open_product = true;
      },
      /*删除商品*/
     deleteImg(index) {
      this.excludeIds.splice(index, 1);
      this.products.splice(index, 1);
    },

      /*关闭产品弹窗*/
      closeProductDialog(e) {
        if (e.type != 'error') {
          e.params.forEach(val => {
            if(this.excludeIds.indexOf(val.product_id) == -1) {
              this.excludeIds.push(val.product_id);
              this.products.push(val);
            }
          });
        }
        this.open_product = false;
      },
      /*修改*/
      edit() {
        let self = this;
        let params = this.form;
        delete params.products
        params.product_ids = this.excludeIds.join(',');
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.submit_loading = true;
            FullreduceApi.edit(params, true)
              .then(data => {
                self.submit_loading = false;
                self.$message({
                  message: '恭喜你，修改成功',
                  type: 'success'
                });
                self.dialogFormVisible(true);

              })
              .catch(error => {
                self.submit_loading = false;
              });

          }
        });
      },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      }

    }
  };
</script>

<style>
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .item {
  position: relative;
  width: 110px;
  height: 130px;
  margin-top: 10px;
  margin-right: 10px;
  overflow: hidden;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}
.draggable-list .item .img {
  width: 80px;
  height: 80px;
}
.product-name2 {
  line-height:20px;
  height: 22px;
  background-color: #aaa;
  position: relative;
  bottom: 0;
  opacity: 0.9;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/fullreduce/Edit.vue